(function () {
  function initialiseHomeRails() {
    document.querySelectorAll('[data-home-product-section]').forEach(function (section) {
      if (section.hasAttribute('data-home-rail-bound')) return;
      var rail = section.querySelector('[data-home-product-rail]');
      var previous = section.querySelector('[data-home-rail-previous]');
      var next = section.querySelector('[data-home-rail-next]');
      if (!rail || !previous || !next) return;
      section.setAttribute('data-home-rail-bound', '');

      function scrollAmount() {
        return Math.max(260, rail.clientWidth * 0.82);
      }

      function updateControls() {
        var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
      }

      previous.addEventListener('click', function () {
        rail.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      rail.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        rail.scrollBy({ left: event.key === 'ArrowLeft' ? -scrollAmount() : scrollAmount(), behavior: 'smooth' });
      });

      rail.addEventListener('wheel', function (event) {
        var maximum = rail.scrollWidth - rail.clientWidth;
        if (maximum <= 0 || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
        var canMove = (event.deltaY < 0 && rail.scrollLeft > 0) || (event.deltaY > 0 && rail.scrollLeft < maximum);
        if (!canMove) return;
        event.preventDefault();
        rail.scrollBy({ left: event.deltaY, behavior: 'auto' });
      }, { passive: false });

      var dragging = false;
      var startX = 0;
      var startScrollLeft = 0;
      rail.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        startX = event.clientX;
        startScrollLeft = rail.scrollLeft;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      });
      rail.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        rail.scrollLeft = startScrollLeft - (event.clientX - startX);
      });
      function stopDragging(event) {
        if (!dragging) return;
        dragging = false;
        rail.classList.remove('is-dragging');
        if (event.pointerId !== undefined && rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
      }
      rail.addEventListener('pointerup', stopDragging);
      rail.addEventListener('pointercancel', stopDragging);
      rail.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      updateControls();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseHomeRails);
  } else {
    initialiseHomeRails();
  }
  document.addEventListener('shopify:section:load', initialiseHomeRails);
})();
